<template>
    <textarea
        ref="editor"
        :name="name"
        :value="modelValue"
    />
</template>

<script>
export default {
    props: {
        modelValue: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: '',
        },
    },
    mounted() {

        import('simplemde/dist/simplemde.min.js').then(module => {

            const SimpleMDE = module.default;
            const self = this;

            const editor = new SimpleMDE({
                element: this.$refs.editor,
                forceSync: true,
                spellChecker: false,
                status: false,
                toolbar: [
                    'bold',
                    'italic',
                    '|',
                    'link',
                    '|',
                    'preview',
                    //'fullscreen',
                    //'heading-1',
                    //'heading-2',
                    //'unordered-list',
                    //'ordered-list',
                    //'table',
                    //'side-by-side',
                ],
            });

            editor.codemirror.on("change", function() {
                self.$emit('update:modelValue', editor.value());
            });

        })

    },
}
</script>

<style>
.CodeMirror, .CodeMirror-scroll {
    min-height: 64px;
}
</style>
